var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            visible: true,
            size: "xl",
            title: `${_vm.item.extendedProps.Name}, ${_vm.format(
              new Date(_vm.item.start),
              "HH:mm"
            )} - ${_vm.format(new Date(_vm.item.end), "HH:mm")}`,
          },
          on: {
            hidden: function ($event) {
              return _vm.$emit("close")
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between w-100" },
                    [
                      _c(
                        "div",
                        [
                          _vm.hasSiblings
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "outline-secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("show-siblings")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("reservation.show_timestamps")
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "outline-secondary",
                                disabled: _vm.isActionLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("close")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("actions.cancel")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.error
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _vm._v("\n            " + _vm._s(_vm.error) + "\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-100", staticStyle: { "max-width": "550px" } },
            [
              _c("dl", { staticClass: "row" }, [
                _c("dt", { staticClass: "col-5" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("common.warehouse")) +
                      ":\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-7" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.extendedProps["Warehouse.Name"]) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("dt", { staticClass: "col-5" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("common.location")) +
                      ":\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-7" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.extendedProps["Location.Name"]) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _vm.item.extendedProps.occupation
                  ? _c("dt", { staticClass: "col-5" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("common.occupation")) +
                          ":\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.extendedProps.occupation
                  ? _c("dd", { staticClass: "col-7 card-text" }, [
                      _vm.item.extendedProps.occupation
                        ? _c("span", [
                            _c(
                              "span",
                              { attrs: { "data-rel": "occupation" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.item.extendedProps
                                      .CurrentEntryQuantity || 0
                                  )
                                ),
                              ]
                            ),
                            _vm._v(
                              " / " +
                                _vm._s(
                                  _vm.item.extendedProps.MaxEntryQuantity
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isPickingTimeInQueue
                        ? _c(
                            "span",
                            { staticClass: "ml-2 badge badge-warning" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("reservation.queue"))
                              ),
                              !_vm.isNull(_vm.queueCount) && _vm.queueCount > 0
                                ? _c(
                                    "span",
                                    { staticClass: "ml-1 badge badge-light" },
                                    [_vm._v(_vm._s(_vm.queueCount))]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              !_vm.isNull(_vm.queueCount)
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-warning w-100",
                      attrs: { role: "alert" },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("reservation.full_moment_queue")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col mb-3" }, [_c("hr")]),
          ]),
          _vm._v(" "),
          _vm.isInitialLoading
            ? _c(
                "div",
                { staticClass: "text-center py-5" },
                [
                  _c("b-spinner", { attrs: { variant: "primary" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("common.loading")) +
                        "\n            "
                    ),
                  ]),
                ],
                1
              )
            : [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col col-lg-6" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col col-12" }, [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("reservation.reserve_with_subscription")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.isLoggedIn
                      ? _c(
                          "div",
                          [
                            _vm.subscriptions.length
                              ? _c(
                                  "b-list-group",
                                  _vm._l(
                                    _vm.subscriptions,
                                    function (subscription) {
                                      return _c(
                                        "b-list-group-item",
                                        {
                                          key: subscription.id,
                                          staticClass:
                                            "d-flex justify-content-between align-items-center",
                                          attrs: {
                                            button: true,
                                            disabled: _vm.isActionLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.reserveWithSubscription(
                                                subscription
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c("strong", [
                                              _vm._v(_vm._s(subscription.name)),
                                            ]),
                                            _vm._v(" "),
                                            subscription.remainingUses !== null
                                              ? _c("small", [
                                                  _vm._v(
                                                    "\n                                        (" +
                                                      _vm._s(
                                                        subscription.remainingUses
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "reservation.uses_remaining"
                                                        )
                                                      ) +
                                                      ")\n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            subscription.dateRange &&
                                            subscription.dateRange?.start &&
                                            subscription.dateRange?.end
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-success",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.validity"
                                                          )
                                                        ) +
                                                        ": " +
                                                        _vm._s(
                                                          _vm.format(
                                                            new Date(
                                                              subscription.dateRange.start
                                                            ),
                                                            "dd-MM-yyyy"
                                                          )
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.format(
                                                            new Date(
                                                              subscription.dateRange.end
                                                            ),
                                                            "dd-MM-yyyy"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant:
                                                  _vm.isPickingTimeInQueue
                                                    ? "outline-dark"
                                                    : "outline-success",
                                                size: "sm",
                                                disabled: _vm.isActionLoading,
                                              },
                                            },
                                            [
                                              _vm.isActionLoading
                                                ? _c("b-spinner", {
                                                    attrs: { small: "" },
                                                  })
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.isPickingTimeInQueue
                                                          ? _vm.$t(
                                                              "actions.join_queue"
                                                            )
                                                          : _vm.$t(
                                                              "actions.reserve"
                                                            )
                                                      )
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "alert alert-info",
                                    staticStyle: { "min-height": "110px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t(
                                            "reservation.no_valid_subscriptions"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _vm.slug
                                      ? _c("div", { staticClass: "mt-3" }, [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn btn-primary",
                                              attrs: { href: _vm.slug },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "reservation.view_available_subscriptions"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                          ],
                          1
                        )
                      : _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-dark text-center pt-4",
                              staticStyle: { "min-height": "110px" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "reservation.have_product_to_reserve"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "alert-link text-nowrap",
                                  attrs: { href: _vm.loginUrl },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("common.click_to_login")) +
                                      "\n                                "
                                  ),
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: _vm.icons.faLock,
                                      size: "sm",
                                      "fixed-width": "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col col-lg-6" },
                    [
                      _c("h5", [
                        _vm._v(
                          _vm._s(_vm.$t("reservation.buy_ticket_for_time"))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.products.length
                        ? _c(
                            "b-list-group",
                            _vm._l(_vm.products, function (product) {
                              return _c(
                                "b-list-group-item",
                                {
                                  key: product.id,
                                  staticClass:
                                    "d-flex justify-content-between align-items-center",
                                  attrs: {
                                    button: true,
                                    disabled: _vm.isActionLoading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addToCart(product)
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(product.name) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "small text-muted" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(product.price) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-primary",
                                        size: "sm",
                                        disabled: _vm.isActionLoading,
                                      },
                                    },
                                    [
                                      _vm.isActionLoading
                                        ? _c("b-spinner", {
                                            attrs: { small: "" },
                                          })
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("actions.add_to_cart")
                                              )
                                            ),
                                          ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "alert alert-info",
                              staticStyle: { "min-height": "110px" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("reservation.no_products_available")
                                  ) +
                                  "\n                        "
                              ),
                              _c("div", { staticClass: "mt-3" }, [
                                _vm.slug
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: { href: _vm.slug },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "reservation.view_available_products"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-link",
                                    attrs: { href: "/contact" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t("reservation.contact_us")
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.showAddedToCartModal
        ? _c("add-to-cart-modal", {
            attrs: { "show-incasso-warning": _vm.hasIncassoProcess },
            on: { close: _vm.closeAddedToCartModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }